module.exports = __webpack_public_path__ + "static/media/AboutIcon01.29043932.png";